// extracted by mini-css-extract-plugin
export default {"logo_text":"OfferHeaderMega_logo_text__tG4k6","title_text":"OfferHeaderMega_title_text__v2F9J","description":"OfferHeaderMega_description__SEILL"};